module.exports = __webpack_public_path__ + "media/bootstrap-icons/lock-fill-cd7f1c01.svg";